import FormItem from "@components/formItem";
import { StakeFieldWrapper } from "@pages/profile-v2/pages/deposit/baseItems";
import { BoxWrapper } from "@pages/profile/withdraw/baseItems";
import { getUser } from "@utils";
import React, { Fragment } from "react";
import { Box, BoxTitle, Content, ContentTitle, StakeInput } from "../baseItems";
import Base from "./base";

export default class Papara extends Base {
	getStep1(translate) {
		const { stake, selectedCurrency } = this.state;
		return (
			<Content>
				<ContentTitle>{translate("Payment_Stake")}</ContentTitle>
				<BoxWrapper>
					{this.getCurrencyField(translate)}
					<Fragment>
						<StakeFieldWrapper>
							<div className="stake-field">{this.getStakeField()}</div>
							<div className="min-max-field">{this.renderMinMax()}</div>
						</StakeFieldWrapper>
						<FormItem onRegister={() => this.registerField({ name: "account" })}>
							<Box>
								<BoxTitle>{translate("ACCOUNT_NUMBER")}</BoxTitle>
								<StakeInput
									placeholder="...................."
									type="number"
									onChange={this.onEnterValue.bind(this, "account")}
								/>
							</Box>
						</FormItem>
					</Fragment>
				</BoxWrapper>
			</Content>
		);
	}

	makeExternalPayment() {
		const { stake, account, selectedCurrency } = this.state;
		let withdrawData = {
			type: "MovenPay-Papara",
			username: getUser().username,
			sessionId: getUser().sessionId,
			amount: {
				value: stake,
				currency: selectedCurrency,
			},
			accountNumber: parseInt(account),
			language: this.getActiveLanguageCode(),
			note: new Date(),
		};
		this.props.onWithdraw(withdrawData, () => {
			this.onBackToWithdrawPage();
		});
	}
}
